import type { SVGProps } from 'react';
export const IdIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="100%"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6 6H6V18H8V6Z" />
    <path d="M11 6 H13 C20,6 20,18 13,18 V8 C17,8 17,16 13,16 V18 H11 Z" fillRule="evenodd" />
  </svg>
);
